import React from "react";

interface EventCodeInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

const EventCodeInput: React.FC<EventCodeInputProps> = ({
  value,
  onChange,
  onSubmit,
}) => (
  <div className="space-y-4">
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Enter event code"
      className="w-full px-6 py-4 rounded-2xl bg-white text-gray-700 text-lg placeholder:text-gray-500 focus:outline-none"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onSubmit();
        }
      }}
    />
    {value && (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={onSubmit}
          className="rounded-full bg-black p-4 hover:bg-gray-900 transition-colors"
          aria-label="Submit event code"
        >
          <svg
            className="w-4 h-4 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={3}
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
        </button>
      </div>
    )}
  </div>
);

export default EventCodeInput;
